import { Component, OnInit } from '@angular/core';

import { PropertiesService } from '@core/services/properties.service';
import { VersionService } from '@shared/services/version.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AdminService } from "@shared/services/admin.service";

@UntilDestroy()
@Component({
  selector: 'app-version',
  templateUrl: './version.component.html'
})
export class VersionComponent implements OnInit {

  loading: boolean;
  feVersion: Version.VersionModel;
  beVersion: Version.BEVersionModel;
  licenceType: any;

  constructor(private propertiesService: PropertiesService,
              private adminService: AdminService,
              private versionService: VersionService) { }

  ngOnInit(): void {
    this.feVersion = this.propertiesService.VERSION;

    this.loading = true;
    this.versionService.get().pipe(untilDestroyed(this)).subscribe((response: Version.BEVersionModel) => {
      this.loading = false;
      const version = response.version.split("-")[0];
      this.beVersion = {
        version
      };
    }, error => {
      this.loading = false;
      console.log('error while fetching version info', error);
    });

    this.adminService.getLicenseKey()
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        this.licenceType = response?.licenceType;
      }, error => {
        console.log('error while fetching license type', error);
      });
  }
}
